const ESCAPE_PARTS = [
  {
    escape: '\\',
    escaped: '\\\\'
  },
  {
    escape: '\u0008',
    escaped: '\\b'
  },
  {
    escape: '\t',
    escaped: '\\t'
  },
  {
    escape: '\n',
    escaped: '\\n'
  },
  {
    escape: '\f',
    escaped: '\\f'
  },
  {
    escape: '\r',
    escaped: '\\r'
  },
  {
    escape: '"',
    escaped: '\\"'
  }
];


const escapeString = (string) => {
  ESCAPE_PARTS.forEach(escapePart => {
    string = string.replaceAll(escapePart.escape, escapePart.escaped);
  })
  return string;
}
const unescapeString = (string) => {
  ESCAPE_PARTS.forEach(escapePart => {
    string = string.replaceAll(escapePart.escaped, escapePart.escape);
  })
  return string;
}

const iterateThroughObjectAndUnescapeStrings = (object) => {
  Object.keys(object).forEach((key) => {
      if (object[key] !== null && (typeof object[key] === 'object' || Array.isArray(object[key]))) {
        iterateThroughObjectAndUnescapeStrings(object[key]);
        return;
      }
      if (typeof object[key] === 'string') {
        object[key] = unescapeString(object[key]);
      }
  });
  return object
}

export function escapeMetisVariables() {
  // console.log(JSON.parse(JSON.stringify(arguments)));
  Object.entries(arguments).forEach(([key, value]) => {
    if (typeof value === "string") {
      arguments[key] = escapeString(value);
    }
  });
  // console.log("escaped args", arguments);
  return arguments;
}

export const unescapeMetisReturnObject = (object) => {
  // console.log("result", object);
  const result = iterateThroughObjectAndUnescapeStrings(object)
  // console.log("unescaped result", result);
  return result;
}

export function convertLinebreaksForMails() {
  // console.log(JSON.parse(JSON.stringify(arguments)));
  Object.entries(arguments).forEach(([key, value]) => {
    if (typeof value === "string") {
      arguments[key] = value.replaceAll('\\\\n', '<br>');
      arguments[key] = arguments[key].replaceAll('\\n', '<br>');
    }
  });
  // console.log("escaped args", arguments);
  return arguments;
}




